import { useTranslation } from "react-i18next";
import {
  ImpersonationBanner,
  type ImpersonationBannerErrorHandler,
  type ImpersonationBannerLabels,
} from "@pps/ui";
import { Sentry, toSentryError } from "@pps/observability";
import { supabase } from "@/integrations/supabase/client";

/**
 * Falha de claim/encerramento da aba de suporte vai ao Sentry (IR-RX-005,
 * IR-OBS-003, IR-OBS-007). Sem toast: a aba é do admin e o próprio banner já
 * finaliza a aba; o que importa é o time ver a falha.
 */
const reportImpersonationError: ImpersonationBannerErrorHandler = (
  error,
  { action },
) => {
  Sentry.captureException(toSentryError(error), {
    tags: { feature: "impersonation", action },
  });
};

export function ImpersonationBannerWrapper() {
  const { t } = useTranslation();
  const labels: ImpersonationBannerLabels = {
    title: t("impersonation.title"),
    renderSubtitle: ({ reason, remaining }) =>
      t("impersonation.subtitle", { reason, remaining }),
    endLabel: t("impersonation.endLabel"),
    endingLabel: t("impersonation.endingLabel"),
    endedTitle: t("impersonation.endedTitle"),
    endedDescription: t("impersonation.endedDescription"),
  };
  return (
    <ImpersonationBanner
      supabase={supabase}
      labels={labels}
      onError={reportImpersonationError}
    />
  );
}
